// Generated by Melange

import * as Fx from "../../fx/fx.jsx";
import * as Subsonic__AlbumInfo from "./albumInfo.jsx";
import * as Subsonic__Utils from "./utils.jsx";

function make(id) {
  const params = {};
  return Fx.Monad_syntax.let$star((params["id"] = {
    TAG: /* Value */ 1,
    _0: id
  }, Subsonic__Utils.makeRequest({
    _method: "rest/getAlbumInfo2",
    params: params
  }, Subsonic__AlbumInfo.of_json)), (function (param) {
    return {
      TAG: /* Ok */ 0,
      _0: param.response.albumInfo
    };
  }));
}

export {
  make,
}
/* No side effect */
